// extracted by mini-css-extract-plugin
export default {"infoButton":"GroupListControll_infoButton__3P5ZF","infoButtonMark":"GroupListControll_infoButtonMark__WOJoQ","groupListControlRow":"GroupListControll_groupListControlRow__Hyj9N"};